import React from 'react';
import i18n from 'i18n-js';
import { useStyles } from './Payment.styled';
import { Box, Typography, Link } from '@material-ui/core';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

export const PaymentNumber = ({ data }) => {
  const classes = useStyles();

  return (
    <Typography>
      <Box fontSize={13} component="span" fontWeight="medium" className={classes.paymentNumber}>
        **** **** **** {data?.last_four}
      </Box>
    </Typography>
  );
};

export const PaymentIcon = ({ type }) => {
  switch (type) {
    case 'credit_card':
      return <CreditCardIcon />;
    case 'ach':
    case 'bank_account':
      return <AccountBalanceIcon />;
    default:
      return <CreditCardIcon />;
  }
};

export const PaymentInfo = ({ data, setCurrentPaymentId, setOpenVerifyPaymentMethod }) => {
  const paymentType = data?.payment_type || data?.type;
  const paymentName = data?.brand || data?.bank_name || '';
  const paymentTypeLabel = i18n.t(
    `payment_methods.${paymentType === 'card' ? data?.card_type : paymentType}`,
    {
      defaultValue: paymentType,
    }
  );
  const paymentExp =
    data?.exp_month && data?.exp_year
      ? `Expiration: ${String(data?.exp_month).padStart(2, '0')}/${data?.exp_year
          ?.toString()
          ?.substr(-2)}`
      : '';
  const showVerify = paymentType === 'ach' && data?.status === 'NEW';
  return (
    <>
      {`${paymentName} ${!['bank_account', 'ach'].includes(paymentType) ? paymentTypeLabel : ''}`}
      {paymentExp ? (
        <>
          <br />
          {`${paymentExp}`}{' '}
        </>
      ) : null}
      {showVerify ? (
        <>
          <br />
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              setCurrentPaymentId(data?.id);
              setOpenVerifyPaymentMethod(true);
            }}
          >
            {i18n.t('organization.verify_account')}
          </Link>
        </>
      ) : null}
    </>
  );
};
